// Kommentar-Verlauf für Aufträge — mehrere Einträge mit Autor+Zeitstempel,
// statt des einzelnen überschreibbaren Kommentarfelds. Wird in den
// Auftrags-Detailseiten aller Produktionsmodule eingebunden.
import { useState } from 'react';
import { useApi } from '../hooks/useApi';
import { api } from '../lib/api';

function fmtZeit(v: string): string {
  const d = new Date(v.includes('T') ? v : v.replace(' ', 'T') + 'Z');
  if (isNaN(d.getTime())) return v;
  return d.toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export function KommentarVerlauf({ modul, recordId }: { modul: string; recordId: number }) {
  const komm = useApi(() => api.orderKommentare.list(modul, recordId), [modul, recordId]);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  const senden = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.orderKommentare.create(modul, recordId, text.trim());
      setText('');
      komm.reload();
    } catch (e) { alert('Fehler: ' + (e as Error).message); }
    setBusy(false);
  };
  const loeschen = async (id: number) => {
    if (!confirm('Kommentar löschen?')) return;
    try { await api.orderKommentare.remove(id); komm.reload(); }
    catch (e) { alert('Fehler: ' + (e as Error).message); }
  };

  return (
    <section className="bg-white rounded-xl border border-slate-200 p-5 mb-4">
      <h2 className="font-semibold text-slate-900 mb-3">💬 Kommentare</h2>
      <div className="flex gap-2 mb-3">
        <input value={text} onChange={e => setText(e.target.value)}
               onKeyDown={e => { if (e.key === 'Enter') void senden(); }}
               placeholder="Kommentar hinzufügen …" className="input flex-1" />
        <button onClick={() => void senden()} disabled={busy || !text.trim()}
                className="bg-brand text-white rounded-lg px-4 py-2 text-sm font-medium hover:opacity-90 disabled:opacity-40 whitespace-nowrap">
          {busy ? 'Sendet …' : 'Senden'}
        </button>
      </div>
      {komm.loading && <div className="text-sm text-slate-400">Lädt …</div>}
      {!komm.loading && (komm.data?.data.length ?? 0) === 0 && (
        <div className="text-sm text-slate-400">Noch keine Kommentare.</div>
      )}
      <ul className="space-y-2">
        {komm.data?.data.map(k => (
          <li key={k.id} className="bg-slate-50 border border-slate-100 rounded-lg px-3 py-2 text-sm flex items-start justify-between gap-3">
            <div>
              <div className="text-slate-800 whitespace-pre-wrap">{k.text}</div>
              <div className="text-xs text-slate-400 mt-0.5">{k.user_name ?? '—'} · {fmtZeit(k.created_at)}</div>
            </div>
            <button onClick={() => void loeschen(k.id)} className="text-slate-300 hover:text-red-600 text-xs shrink-0">✕</button>
          </li>
        ))}
      </ul>
    </section>
  );
}
